document.addEventListener("DOMContentLoaded", function () {
    // 📌 Inicializar WaveSurfer para la pista principal
    const wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "black",
        progressColor: "red",
        cursorColor: "transparent",
        barWidth: 2,
        responsive: true,
        height: 80,
        backend: 'MediaElement', // Carga más rápida con HTML5
        preload: 'auto', // Precarga para evitar retrasos
        autoplay: false
    });

    // 🔥 Precargar la pista principal antes de que el usuario la reproduzca
    wavesurfer.load("https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_7.mp3?v=1760652040");

    // 🎵 Botón de Play/Pause para la pista principal
    const playPauseBtn = document.getElementById("playPauseBtn");
    playPauseBtn.addEventListener("click", () => {
        if (wavesurfer.isPlaying()) {
            wavesurfer.pause();
            playPauseBtn.textContent = "▶";
        } else {
            wavesurfer.play();
            playPauseBtn.textContent = "⏸";
        }
    });

    // 🔥 Lista de muestras de audio con precarga mejorada
    const samples = [
        { id: "waveform1", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_6.mp3?v=1760652040" },
        { id: "waveform2", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_4.mp3?v=1760652040" },
        { id: "waveform3", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_2.mp3?v=1760652040" },
        { id: "waveform4", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_3.mp3?v=1760652040" },
        { id: "waveform5", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_1.mp3?v=1760652040" },
        { id: "waveform6", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/PHRASEO_5.mp3?v=1760652040" }
    ];

    let wavesurfers = {};

    // 🔥 Precargar todos los audios antes de que el usuario los use
    function preloadAudio(sample) {
        const audio = new Audio(sample.file);
        audio.preload = "auto";
    }

    samples.forEach(preloadAudio); // Precarga de los audios

    // 📌 Inicializar WaveSurfer para cada muestra de audio
    samples.forEach(sample => {
        wavesurfers[sample.id] = WaveSurfer.create({
            container: `#${sample.id}`,
            waveColor: "black",
            progressColor: "red",
            cursorColor: "transparent",
            barWidth: 2,
            responsive: true,
            height: 40,
            backend: 'MediaElement', // Backend de HTML5 para mejor rendimiento
            preload: 'auto' // Precarga de audios
        });
        wavesurfers[sample.id].load(sample.file);
    });

    // 🎵 Botones de reproducción de muestras
    document.querySelectorAll(".play-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const sampleContainer = this.closest(".sample");
            const waveformDiv = sampleContainer.querySelector(".waveform");
            const waveformId = waveformDiv.id;

            if (wavesurfers[waveformId].isPlaying()) {
                wavesurfers[waveformId].pause();
                this.textContent = "▶";
            } else {
                // 📌 Pausar todos los audios antes de reproducir el nuevo
                Object.keys(wavesurfers).forEach(id => wavesurfers[id].pause());
                document.querySelectorAll(".play-btn").forEach(b => (b.textContent = "▶"));

                wavesurfers[waveformId].play();
                this.textContent = "⏸";
            }
        });
    });

    // 📌 Función para abrir y cerrar preguntas frecuentes (FAQ)
    document.querySelectorAll(".faq-question").forEach(btn => {
        btn.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const toggleSign = this.querySelector(".faq-toggle");

            if (answer.style.maxHeight) {
                answer.style.maxHeight = null;
                answer.style.opacity = "0";
                toggleSign.textContent = "+";
            } else {
                // Cerrar todas las demás preguntas antes de abrir una
                document.querySelectorAll(".faq-answer").forEach(ans => {
                    ans.style.maxHeight = null;
                    ans.style.opacity = "0";
                });
                document.querySelectorAll(".faq-toggle").forEach(sign => (sign.textContent = "+"));

                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.opacity = "1";
                toggleSign.textContent = "-";
            }
        });
    });
});

